export function getRoles(type) {
  switch(type) {
    case 'album':
      return ['reader'];
    case 'folder':
      return ['reader'];
    case 'stream':
      return ['contributor', 'reader'];
  }
}